import { createContext } from "react";
import PropTypes from "prop-types";

export const DataContext = createContext({});

export const DataContextProvider = ({ data, children }) => (
  <DataContext.Provider value={{ ...data }}>{children}</DataContext.Provider>
);

DataContextProvider.defaultProps = {
  data: {},
};

DataContextProvider.propTypes = {
  data: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
};
